import React, { createContext, useMemo } from 'react';
import AuthService from '../services/AuthService';
import { block, unblock } from '../helpers/loading';
import { axiosPublic } from '../helpers/axios';
import { useLocalStorage } from '../services/useLocalStorage';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
	const [user, setUser] = useLocalStorage('user', null);
	const [convo] = useLocalStorage('convo_id');

	// call this function when you want to stablish the user
	const login = (data) => {
		setUser(data);
	};

	// call this function when you have one user amd want to check the token
	const resetLogin = async () => {
		block();
		if (!user) AuthService.logout();
		else {
			const { identidad, token } = user;
			await axiosPublic('auth', { token: token, identidad: identidad, id_convocatoria: convo }, 'GET')
				.then((response) => {
					setUser(response.data);
					unblock();
				})
				.catch((error) => {
					unblock();
					setUser(null);
				});
		}
	};

	// call this function to sign out logged in user
	const logout = () => {
		setUser(null);
	};

	const value = useMemo(
		() => ({
			user,
			login,
			resetLogin,
			logout,
		}),
		[user]
	);

	return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
